<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    {{ label[hook] }}
    <b-form-input v-model="innerValue.args.name" 
      placeholder="(バフ名称)"
      class="action" />
  </div>
</template>

<script>
import Hook from './Hook'
export default {
  extends: Hook
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
  width: 200px;
}
</style>